// extracted by mini-css-extract-plugin
export default {"container":"tableServiceStyle_container__u07oy","service":"tableServiceStyle_service__e18Fv"};